module.exports = __webpack_public_path__ + "img/Subtract.5ee8291e.svg";